import { defineMessages } from 'react-intl';

/** The note of the web SoundCloud card about the second sign-in (design soundcloud-insights b1). */
export const soundCloudInsightsMessages = defineMessages({
  none: {
    id: 'app.sml.soundcloud.insights.note.none',
    defaultMessage:
      'Use the MUSIC24 app to get more SoundCloud data: plays by day, listeners, countries, cities and play sources.',
  },
  connected: {
    id: 'app.sml.soundcloud.insights.note.connected',
    defaultMessage: 'More data comes from your sign-in in the MUSIC24 app.',
  },
  expired: {
    id: 'app.sml.soundcloud.insights.note.expired',
    defaultMessage: 'The data sign-in ended. Sign in again in the MUSIC24 app.',
  },
  getApp: { id: 'app.sml.soundcloud.insights.getApp', defaultMessage: 'Get the app' },
  openApp: { id: 'app.sml.soundcloud.insights.openApp', defaultMessage: 'Open the app' },
});
